module.exports = __webpack_public_path__ + "img/OrangeFiat500.4383123a.jpg";